import React, { useState, useEffect } from 'react';
import API from '../api';

const emptyForm = { username: '', password: '', confirmPassword: '', role: 'NURSE' };

const roleLabel = (role) => role === 'ADMIN' ? 'Administrator' : (role === 'NURSE' ? 'Medicinska sestra' : role);

const UsersPanel = () => {
    const [users, setUsers] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [form, setForm] = useState(emptyForm);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        fetchUsers();
    }, []);

    const fetchUsers = async () => {
        try {
            const res = await API.get('/users');
            setUsers(res.data);
        } catch (err) {
            console.error("Greška pri učitavanju naloga", err);
        }
    };

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleCreate = async (e) => {
        e.preventDefault();
        setError('');

        if (form.password !== form.confirmPassword) {
            setError('Lozinka i potvrda lozinke se ne poklapaju.');
            return;
        }

        setSaving(true);
        try {
            await API.post('/users', {
                username: form.username,
                password: form.password,
                role: form.role
            });
            setForm(emptyForm);
            setShowForm(false);
            fetchUsers();
        } catch (err) {
            setError(err.response?.data?.message || 'Greška pri kreiranju naloga.');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.header}>
                <h2 style={styles.title}>Nalozi</h2>
                <button style={styles.addBtn} onClick={() => setShowForm(!showForm)}>
                    {showForm ? 'Zatvori' : '+ Novi nalog'}
                </button>
            </div>
            <p style={styles.hint}>
                Ovde admin pravi naloge za medicinske sestre (ili druge administratore) koji se koriste za prijavu u aplikaciju.
            </p>

            {showForm && (
                <form onSubmit={handleCreate} style={styles.form}>
                    <input name="username" placeholder="Korisničko ime" value={form.username} onChange={handleChange} required style={styles.input} />
                    <select name="role" value={form.role} onChange={handleChange} style={styles.input}>
                        <option value="NURSE">Medicinska sestra</option>
                        <option value="ADMIN">Administrator</option>
                    </select>
                    <input name="password" type="password" placeholder="Lozinka" value={form.password} onChange={handleChange} required style={styles.input} />
                    <input name="confirmPassword" type="password" placeholder="Potvrdi lozinku" value={form.confirmPassword} onChange={handleChange} required style={styles.input} />
                    {error && <div style={styles.error}>{error}</div>}
                    <button type="submit" style={{ ...styles.saveBtn, opacity: saving ? 0.6 : 1 }} disabled={saving}>
                        {saving ? 'Čuvanje...' : 'Sačuvaj nalog'}
                    </button>
                </form>
            )}

            <div style={styles.listWrapper}>
                {users.length > 0 ? (
                    users.map(u => (
                        <div key={u.userID} style={styles.row}>
                            <div style={styles.info}>
                                <div style={styles.name}>{u.username}</div>
                                <div style={styles.subtext}>{roleLabel(u.roles)}</div>
                            </div>
                        </div>
                    ))
                ) : (
                    <div style={{ textAlign: 'center', padding: '30px', color: '#888' }}>
                        Nema naloga.
                    </div>
                )}
            </div>
        </div>
    );
};

const styles = {
    container: {
        maxWidth: '800px',
        margin: '0 auto',
        padding: '15px',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    },
    header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' },
    title: { margin: 0, fontSize: '24px', color: '#1f2937' },
    hint: { fontSize: '13px', color: '#7f8c8d', marginBottom: '20px', lineHeight: '1.5' },
    addBtn: { padding: '10px 15px', backgroundColor: '#27ae60', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' },
    form: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '10px',
        padding: '15px',
        backgroundColor: '#f1f3f5',
        borderRadius: '10px',
        marginBottom: '20px'
    },
    input: { padding: '12px', border: '1px solid #ccc', borderRadius: '6px', boxSizing: 'border-box' },
    error: { gridColumn: 'span 2', color: '#e74c3c', fontSize: '13px' },
    saveBtn: { gridColumn: 'span 2', padding: '12px', backgroundColor: '#2980b9', color: 'white', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' },
    listWrapper: { backgroundColor: 'white', borderRadius: '10px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' },
    row: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '15px',
        borderBottom: '1px solid #eee',
        gap: '10px',
        flexWrap: 'wrap'
    },
    info: { display: 'flex', flexDirection: 'column' },
    name: { fontSize: '17px', fontWeight: '600', color: '#1f2937', marginBottom: '4px' },
    subtext: { fontSize: '13px', color: '#7f8c8d' }
};

export default UsersPanel;
